import { create } from 'zustand';

import { USER_ID_SESSION_STORAGE_KEY } from 'constants/session';
import { getSessionStorageItem, removeSessionStorageItem, setSessionStorageItem } from 'utils/storage';

interface RegistrationSessionActions {
    userIdAssigned: (userId: string) => void;
    userIdCleared: () => void;
}

interface RegistrationSessionState {
    /** User id of the in-progress signup. Empty string when none. */
    userId: string;
    actions: RegistrationSessionActions;
}

// sessionStorage-backed so an in-progress signup survives a reload within the
// same tab. All three accesses go through utils/storage, which resolves the
// global defensively — reading `window.sessionStorage` itself throws in a
// sandboxed iframe or a browser configured to block site data, and
// `userIdCleared` in particular runs mid-logout, where an escaping exception
// would strand the rest of the teardown.
export const useRegistrationSessionStore = create<RegistrationSessionState>()((set) => ({
    userId: getSessionStorageItem(USER_ID_SESSION_STORAGE_KEY) ?? '',
    actions: {
        userIdAssigned: (userId) => {
            setSessionStorageItem(USER_ID_SESSION_STORAGE_KEY, userId);
            set({ userId });
        },
        userIdCleared: () => {
            removeSessionStorageItem(USER_ID_SESSION_STORAGE_KEY);
            set({ userId: '' });
        },
    },
}));
